import axios from "axios";

export default {
  async all(params, instanceId) {
    let result = await axios.get(
      `/api/v1/instances/${instanceId}/campaigns`,
      {
        params: params
      }
    );
    return result.data.data;
  },
  async find(id, instanceId, params) {
    let result = await axios.get(
      `/api/v1/instances/${instanceId}/campaigns/${id}`,
      {
        params: params
      }
    );
    return result.data.data;
  },
  async create(payload, instanceId) {
    let result = await axios.post(
      `/api/v1/instances/${instanceId}/campaigns`,
      payload
    );
    return result.data.data;
  },
  async update(payload, instanceId, id) {
    let result = await axios.patch(
      `/api/v1/instances/${instanceId}/campaigns/${id}`,
      payload
    );
    return result.data.data;
  },
  async delete(instanceId, id) {
    let result = await axios.delete(
      `/api/v1/instances/${instanceId}/campaigns/${id}`
    );
    return result.data.data;
  }
}
